export const APP_LOCAL_STORAGE_PREFIX = 'admin_fanzone'
export const USER_DATA_LOCAL_STORAGE_KEY = 'user'

export const FANZONE_STATUS_OPTIONS = [
  { value: 0, text: 'unknown' },
  { value: 1, text: 'enabled' },
  { value: 9, text: 'disabled' },
]

export const ARTIST_STATUS_OPTIONS = [
  { value: 0, text: 'unknown' },
  { value: 1, text: 'enabled' },
  { value: 9, text: 'disabled' },
]

export const FANZONE_TYPE_OPTIONS = [
  { value: 0, text: 'unknown' },
  { value: 1, text: 'festiwale' },
  { value: 2, text: 'akcje miejskie' },
  { value: 3, text: 'miejsca' },
  { value: 4, text: 'trasy koncertowe' },
]

export const FANZONE_VISIBILITY_OPTIONS = [
  { value: 0, text: 'unknown' },
  { value: 1, text: 'testing' },
  { value: 9, text: 'production' },
]

export const SOCIAL_MEDIA_WRAPPER_OPTIONS = [
  { value: 'webview', text: 'WEBVIEW' },
  { value: 'default_browser', text: 'DEFAULT_BROWSER' },
]


export const LOCALES = ['pl', 'en']

